// extracted by mini-css-extract-plugin
module.exports = {"root":"_d963c2","container":"_0abb6b","breadcrumb":"_ef504f","breadcrumbItem":"_fe7ab9"};